import { Box, Alert } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTeacherSchema } from "../../schema/teacherSchema";
import { mockTeacherRegisterFields } from "../../data/mockTeacherData";
import { createTeacher }  from "../../api/teacher";
import { getLocalStorageValue } from "../../utils/localStorage";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  phoneNumber: "",
  cnic: "",
  qualification: "",
  profilePicture: null,
};

const TeacherRegister = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("teacher");
    if (result) {
      navigate("/teacherDashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(async (values, { resetForm }) => {
    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("password", values.password);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("cnic", values.cnic);
    formData.append("qualification", values.qualification);
    formData.append("profilePicture", values.profilePicture);

    try {
      await createTeacher(formData);
      resetForm();
      navigate("/teacherLogin");
    } catch (error) {
      setAlertMessage(error.response.data.msg);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
    
  }, [navigate]);

  return (
    <AuthLayout title="Register Teacher">
      {/* Alert */}
      {showAlert && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {alertMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={createTeacherSchema}
        fields={mockTeacherRegisterFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you already have an account"
          link="teacherLogin"
          linkText="login"
          buttonText="Create New Teacher"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default TeacherRegister;
